module.exports = __webpack_public_path__ + "img/icon-supervisor-case-cover.9c091760.png";